export default "__VITE_ASSET__Dg7Y_CuZ__"